import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';

import api from '../../services/api';
import { Row } from './styles';
import { Container, Cards, Card, Title, ViewInput} from './../../GlobalStyles';
import Loader from '../../components/Loader';
import photoUser from '../../images/user.png';
import { toast } from 'react-toastify';
import { Button, Modal, Input, Pagination, Select } from 'antd';
import { GoTasklist } from "react-icons/go";

const { TextArea } = Input;

const SignUp = () => {
  const [users, setUsers] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [usersTotal, setUsersTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [accept, setAccept] = useState(false)
  const [observation, setObservation] = useState("")
  const [page, setPage] = useState(0)
  const [room, setRoom] = useState("")
  const [user, setUser] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  const [isLoadingModal, setIsLoadingModal] = useState(false)

  useEffect(() => {
    loadRooms()
  }, []);

  useEffect(() => {
    loadUsersPending()
  }, [page]);


async function loadRooms() {
  await api.get(`/rooms?all=true`).then((response) => {
   let rooms = response.data.rooms
   rooms.map((item)=>{
      item.value = item.id
      item.label = item.name
   })
   setRooms(rooms)
  }).catch(({ response }) => {
    if (response) {
      if (response.data) {
        if (response.data.message) {
          toast.warn(response.data.message)
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
      } else {
        toast.error("Erro Interno. verifique sua conexão e tente novamente")
      }
    } else {
      toast.error("Erro Interno. verifique sua conexão e tente novamente")
    }
  })
}

  async function loadUsersPending() {
   await api.get(`/users-pending?page=${page}`).then((response) => {
     setUsers(response.data.users)
     setUsersTotal(response.data.usersTotal)
    }).catch(({ response }) => {
      if (response) {
        if (response.data) {
          if (response.data.message) {
            toast.warn(response.data.message)
          } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente")
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
      } else {
        toast.error("Erro Interno. verifique sua conexão e tente novamente")
      }
    })
   setIsLoading(false);
  }

  async function responseSignup() {
    setIsLoadingModal(true)
    if (accept) {
      if (!room){
        toast.warning("Sala do Usuário é obrigatório");
        setIsLoadingModal(false)
        return ""
      } 
    } else {
      if (!observation){
        toast.warning("Deixe uma mensagem para o usuário");
        setIsLoadingModal(false)
        return ""
      } 
    }
      await api.put(`/status-user/${user.id}`, {
        status: accept ? "aprovado" : "reprovado",
        observation: observation,
        room_id: room
      }).then((response) => {
        toast.success( accept ? "Usuário aprovado com sucesso" : "Usuário reprovado com sucesso")
        setIsOpen(false)
        loadUsersPending()
      }).catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message)
            } else {
              toast.error("Erro Interno. verifique sua conexão e tente novamente")
            }
          } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente")
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
      })
    setIsLoadingModal(false)
  }


  return (
    <Container>
      <Title>
        <h2>Cadastros Pendentes</h2>
      </Title>
      <Cards>
        <Card>
          <div className="icon">
            <GoTasklist color="#848484" size={32} />
          </div>
          <div className="number">
            <CountUp duration={1} end={usersTotal} />
            <p>Total de Cadastros</p>
          </div>
        </Card>
      </Cards>

      {!isLoading && (
        <>
          {users.length ? (
              <>
                <Row>
                    {
                      users.map(user => (
                        <div key={user.id} className='user'>
                          <img src={user.photo_url || photoUser} />
                          <p>Nome: {user.name}</p>
                          <p>Email: {user.email}</p>
                          <p>Telefone: {user.phone_number ? user.phone_number.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3") : "Não cadastrado"}</p>
                          {!!user.observation && (<p>Observação: {user.observation}</p>)}
                          <row style={{width: "100%", display: "flex", justifyContent: "space-between"}}>
                            <Button
                              type="primary"
                              style={{ background: "#2c2" }}
                              onClick={() => {
                                setAccept(true)
                                setUser(user)
                                setObservation("")
                                setRoom("")
                                setIsOpen(true)
                              }}
                            >
                              Aprovar
                            </Button>
                            <Button
                              type="primary"
                              style={{ background: "#c22" }}
                              onClick={() => {
                                setAccept(false)
                                setUser(user)
                                setObservation("")
                                setRoom("")
                                setIsOpen(true)
                              }}
                            >
                              Reprovar
                            </Button>
                          </row>
                        </div>
                      ))
                    }
                  </Row>
                  <center style={{marginTop: 15}}>
                    <Pagination simple defaultCurrent={page + 1} onChange={(page) => {
                      setPage(page - 1)
                   }} total={usersTotal} pageSize={30} 
                   showTotal={(total) => `${total} cadastros`}/>
                  </center>
                </>
              )
              : (
                <div className="error">
                  <p>Nenhum cadastro encontrado</p>
                </div>
              )}
        </>
      )}

      {isLoading && <Loader />}
      <Modal title={"Cadastro Pendente"} width={500} confirmLoading={isLoadingModal} open={isOpen} okButtonProps={{
        style: accept ? {
          background: "#2d2"
        } : {}
      }} okText={accept ? "APROVAR USUÁRIO" : "REPROVAR USUÁRIO"} cancelText="FECHAR" onOk={() => { 
          responseSignup()
      }} onCancel={() => {
        setIsOpen(false)
      }}>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: 25 }}>
            <row style={{display: "flex", alignItems: "center", marginBottom: 15}}>
              <img style={{width: 50, height: 50, borderRadius: 50}} src={user.photo_url || photoUser} />
            <div style={{flexDirection: "column", marginLeft: 25}} >
              <p>Nome: {user.name}</p>
                          <p>Email: {user.email}</p>
                          <p>Telefone: {user.phone_number ? user.phone_number.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3") : "Não cadastrado"}</p>
                          {!!user.observation && (<p>Observação: {user.observation}</p>)}
              </div>     
                          
                        </row>
                {
                  accept && (
                    <ViewInput>
                      <p>Selecione a Sala*</p>
                <Select
                  options={rooms}
                  placeholder="selecione a sala"
                        style={{width: "100%", textAlign: "left"}}
                        value={room || null}
                        onChange={(room) => setRoom(room)} />
                    </ViewInput>
                  )
                }        
          <ViewInput>
            <p>{accept ? "Observação" : "Mensagem para o Usuário*"}</p>
            <TextArea
              placeholder="deixe uma observação"
              autoSize={{ maxRows: 5}}
              style={{
                  minWidth: "100%",
                  display: 'flex',
                  alignItems: 'center',
                  paddingTop: 7
              }}
              value={observation}
              onChange={(event) => setObservation(event.target.value)} />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
};

export default SignUp;
